module.exports = __webpack_public_path__ + "static/media/dashboard_employees.025aa2c3.png";